import React, { useEffect, useState, useRef } from 'react'
import { SERVER_API } from '../../authentication/qlCalls'
// /{ amount, detail, order_id, phone, email, name, hash }

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')

  const regex = new RegExp(`[\\?&]${name}"=([^&#]*)`)
  // const s = new  URLSearchParams(window.location.hash)
  // const s = `http://${str[1]}`;
  // const url = new URL(s);
  if (window.location.hash !== null || window.location.hash !== undefined) {
    var hash = window.location.hash
    var queryString = hash.substring(hash.indexOf('?'))
    var params = new URLSearchParams(queryString)
    console.log(params)
    const results = params.get(name)
    return results === null ? '' : decodeURIComponent(results)
  }
  return ''
}

let amount = getUrlParameter('am')
let recId = getUrlParameter('recId')
let detail = getUrlParameter('detail')
let order_id = getUrlParameter('order_id')
let phone = getUrlParameter('phone')
let email = getUrlParameter('email')
let name = getUrlParameter('name')
let hash = getUrlParameter('hash')
const SenangPayRec = () => {
  const formRef = useRef(null)
  const [paymentLinkStatus, setPaymentLinkStatus] = useState('')
  const [message, setMessage] = useState('')
  const [enableSubmit, setEnableSubmit] = useState(false)
  useEffect(() => {
    const fetchData = async () => {
      await handleRetrievePL()
    }

    fetchData()
    //alert(hash)
    /* alert(amount)
    alert(detail)
    alert(order_id)
    alert(phone)
    alert(email)
    alert(name)
    */
  }, [])

  useEffect(() => {
    if (paymentLinkStatus !== '' && paymentLinkStatus !== null && paymentLinkStatus !== undefined) {
      if (paymentLinkStatus === 'pending_payment') {
        setEnableSubmit(true)
        if (formRef.current) {
          // formRef.current.submit()
        }
      } else {
        setMessage('Link Expired')
        setEnableSubmit(false)
      }
    } else {
      setMessage('Checking..')
      setEnableSubmit(false)
    }
  }, [paymentLinkStatus])

  const handleRetrievePL = async () => {
    await getpaymentlist()
  }

  const getpaymentlist = async () => {
    var sesKey = localStorage.getItem('sessionKey')

    const query = `query{checkpaymentstatus(sessionToken:\"${sesKey}\", orderId:\"${order_id}\" ){  orderId,   status, datetime_created,  datetime_modified}}`

    const getBody = (query, variables) => {
      return {
        OperationName: '',
        Query: query,
        Variables: variables,
      }
    }

    // https://stackoverflow.com/questions/42147733/doing-a-timeout-error-with-fetch-react-native
    let controller = new AbortController()
    setTimeout(() => controller.abort(), 3000)

    const response = await fetch(
      SERVER_API,
      {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(getBody(query)),
      },
      { signal: controller.signal },
    )

    const json = await response.json()

    console.log('json', json)
    if (!response.ok) {
      if (response.status === 400) {
        alert('Invalid session response')
        throw new Error('Invalid session esponse')
      }
      alert('System error, please login later')
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    if (response.ok) {
      const data = json
      console.log('data', data)
      if (data.data.checkpaymentstatus !== null) {
        setPaymentLinkStatus(data.data.checkpaymentstatus.status)
      }
    }
  }

  return (
    <div>
      <div>{message}</div>
      <form
        ref={formRef}
        action="https://api.senangpay.my/recurring/payment/207172241514017"
        method="POST"
      >
        <input type="hidden" name="recurring_id" value={recId} />
        <input type="hidden" name="order_id" value={order_id} />
        <input type="hidden" name="phone" value={phone} />
        <input type="hidden" name="email" value={email} />
        <input type="hidden" name="name" value={name} />
        <input type="hidden" name="hash" value={hash} />
        <input type="hidden" name="amount" value={'2.00'} />
        {enableSubmit ? <button type="submit">Submit</button> : null}
      </form>
    </div>
  )
}

export default SenangPayRec
